// Gestion partagée des erreurs de validation des wizards loan (devis et adhésion)
// Seul le premier champ en erreur affiche sa bulle (.loan-field-first-error), les autres restent en rouge
export const scrollToFirstErrorInScreen = (targetScreen: number) => {
    setTimeout(() => {
        document.querySelector('.loan-field-first-error')?.classList.remove('loan-field-first-error')

        const firstError = document.querySelector(`[data-loan-screen="${targetScreen}"] .loan-field-has-error`)
        if (firstError) {
            firstError.classList.add('loan-field-first-error')
            // scroll instantané : un 'smooth' est ignoré quand l'écran vient de changer, laissant le champ hors vue
            firstError.scrollIntoView({ block: 'center' })
            const focusable = firstError.querySelector(
                'input, select:not(.sr-only), button[type="button"].w-full'
            ) as HTMLElement
            if (focusable) {
                focusable.focus({ preventScroll: true })
            }
        }
    }, 100)
}

// Après une validation multi-écrans : bascule sur le premier écran fautif puis scrolle
export const goToFirstScreenWithError = (
    orderedScreens: number[],
    currentScreen: number,
    goToScreen: (screen: number) => void
) => {
    setTimeout(() => {
        for (const errorScreen of orderedScreens) {
            if (document.querySelector(`[data-loan-screen="${errorScreen}"] .loan-field-has-error`)) {
                if (errorScreen !== currentScreen) goToScreen(errorScreen)
                scrollToFirstErrorInScreen(errorScreen)
                return
            }
        }
    }, 100)
}
